<template>
  <div class="delete-user-type-wrapper">
    <h4 class="allareakiosk-header">
      {{ $t("sitesAndDevices.siteActions.deleteSite") }}
    </h4>

    <p
      class="custom-Question"
      v-html="$t('sitesAndDevices.deleteSiteConfirm', { site: siteName })"
    />
    <p class="confirmation-msg">
      {{ $t("sitesAndDevices.notes.onAreaDelete") }}
    </p>

    <div class="actionsline-inside"></div>
    <div class="actions-btns">
      <button
        class="submit-btn btn btn-primary add-submit"
        type="button"
        :disabled="loading"
        @click="$bvModal.hide('deleteSite')"
      >
        {{ $t("common.cancel") }}
      </button>
      <button
        type="submit"
        class="btn btn-outline-danger cancel-reject"
        :class="{ 'cursor-stop': loading }"
        size="md"
        :disabled="loading"
        @click="deleteSiteFromList(siteId)"
      >
        {{ $t("common.delete") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      submitted: false,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  beforeMount() {
    this.siteName = this.getModalInfo.name;
    this.siteId = this.getModalInfo.id;
  },
  methods: {
    deleteSiteFromList() {
      // this.submitted = true;
      this.$emit("deleteSiteFromList", this.siteId);
    },
  },
};
</script>

<style>
.cursor-stop {
  cursor: not-allowed;
}
</style>
